//----------
// get next
//----------
export default function getNext(id, array) {
  let match = null;
  let idx = array.findIndex((x) => x.id === id);
  idx++;
  if (idx > array.length - 1) idx = 0;
  match = array[idx];
  //---------
  // returns
  //---------
  return match;
}
